module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_9006.09aaef23.png";